import { useState } from 'react'
import { SafeStorage } from '@/lib/utils/safe-storage'

const localStorageWrapper =
  typeof window !== 'undefined' && typeof localStorage !== 'undefined'
    ? new SafeStorage(localStorage)
    : null

export const useLocalStorage = <T>(
  key: string,
  initialValue: T
): [T, (value: T) => void] => {
  const [storedValue, setStoredValue] = useState<T>(() => {
    return localStorageWrapper?.getItem(key, initialValue) ?? initialValue
  })

  const setValue = (value: T) => {
    setStoredValue(value)
    localStorageWrapper?.setItem(key, value)
  }

  return [storedValue, setValue]
}
